import styled, { css, keyframes } from 'styled-components';
import { ReactComponent as MascotIcon } from '../../../assets/ai-mascot-small.svg';
import { Flex } from '../../Flex';

const pulse = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.7; transform: scale(0.94); }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const Wrapper = styled(Flex)<{ $maxWidth?: number }>`
  align-items: center;
  gap: 8px;
  animation: ${fadeIn} 200ms ease-out;
  ${({ $maxWidth }) =>
    $maxWidth &&
    `
    max-width: ${$maxWidth}px;
    width: 100%;
    margin: 0 auto;
  `}
`;

const Mascot = styled.span<{ $working: boolean }>`
  display: inline-flex;
  height: 18px;
  width: auto;
  flex-shrink: 0;
  ${({ $working }) =>
    $working &&
    css`
      animation: ${pulse} 1.4s ease-in-out infinite;
    `}

  svg {
    height: 100%;
    width: auto;
    display: block;
  }
`;

const StatusText = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.palette.common.gray4};
`;

export type AssistantStatus = 'idle' | 'working';

type Props = {
  status: AssistantStatus;
  contentMaxWidth?: number;
};

const AssistantStatusIndicator = ({ status, contentMaxWidth }: Props) => (
  <Wrapper $maxWidth={contentMaxWidth}>
    <Mascot $working={status === 'working'}>
      <MascotIcon />
    </Mascot>
    {status === 'working' && <StatusText>Working...</StatusText>}
  </Wrapper>
);

export default AssistantStatusIndicator;
